<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        :title="title"
        :small="true"
        :addClose="true"
        @close="close"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>
      <dean-select-form-row id="oldStatus" label="oude status" placeholder="kies een oude status"
                            v-if="!this.isChangeSingle"
                            :value="currentlySelectedOption('oldStatus')"
                            @input="statusFieldChanged"
                            :options="selectOptions.oldStatus"
                            :requiredField="!this.isChangeSingle ? true : false"></dean-select-form-row>
      <dean-select-form-row id="status" label="status" placeholder="kies een nieuw status"
                            :disabled="!this.isChangeSingle && this.data.oldStatus === null"
                            :value="currentlySelectedOption('status')"
                            @input="data.status = $event.value"
                            :options="selectOptions.status"
                            :requiredField="true"
                            :warning="$v.data.status.$error"></dean-select-form-row>
      <date-input
          v-if="data.status && statusHasDate(data.status)"
          :label="statusHasDate(data.status).dateLabel"
          :placeholder="statusHasDate(data.status).dateLabel"
          :value="data.date"
          :min-date="minimumDate"
          :required-field="true"
          @dateValueChanged="dateValueChanged"></date-input>

      <dean-form-row id="comment" label="opmerking"
                     v-model="data.comment"
                     :required-field="this.currentlySelectedOption('status') === 'Afgewezen'"
                     :warning="$v.data.comment.$error"
                     @focus="$v.data.comment.$touch()"
      ></dean-form-row>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import axios from 'axios';
import {deanDialog, warningIcon,} from '@deanone/dean-components';
import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import {deanDialogBus} from '@/main';
import {validationMixin} from 'vuelidate';
import {maxLength, required} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import {createNotification, validationMessage} from '@/mixins/validations';
import {getErrorCodeFromResponse, getErrorFromResponse, getErrorMessageFromResponse} from '@/mixins/errorMessage';
import DateInput from '@/components/DateInput.vue';
import {OrderErrorTranslationsEnum, OrderErrorTranslationsEnumType} from "@/enums/OrderErrorTranslationsEnum";
import {OrderStatusIdEnum} from "@/enums/OrderStatusEnum";
import {ServiceTagEnum} from "@/enums/ServiceTagEnum";
import {ServiceTypeEnum} from "@/enums/ServiceTypeEnum";

interface StatusObject {
  status: string;
  servicesRequireDate: string[];
  tagsRequireDate: string[];
  dateLabel: string;
}

@Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      DateInput,
    },
    mixins: [validationMixin],
  })

  export default class OrderChangeStatus extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: any,
    };
    public data: { [key: string]: any } = {
      status: null,
      oldStatus: null,
      date: null,
      comment: null,
    };

    public isChangeSingle: boolean = false;
    public minDate: string | null = '2022/08/17';

    public selectOptions: { [key: string]: any[] } = {
      status: [],
      oldStatus: [],
    };

    public statusWithDate: Array<StatusObject> = [
      {
        status: OrderStatusIdEnum.PLANNED,
        servicesRequireDate: [
          ServiceTypeEnum.CLOUD, ServiceTypeEnum.MOBILE_ODIDO, ServiceTypeEnum.MOBILE_KPN, ServiceTypeEnum.CONNECTION, ServiceTypeEnum.SIP_TRUNK,
        ],
        tagsRequireDate: [
          ServiceTagEnum.CLOUD, ServiceTagEnum.SIP_TRUNK, ServiceTagEnum.PHONE_NUMBERS_NEW, ServiceTagEnum.PHONE_NUMBERS_PORTING,
          ServiceTagEnum.CONNECTION, ServiceTagEnum.HARDWARE, ServiceTagEnum.MOBILE, ServiceTagEnum.MOBILE_KPN,
        ],
        dateLabel: 'plandatum'
      },
      {
        status: OrderStatusIdEnum.INVOICED,
        servicesRequireDate: [
          ServiceTypeEnum.CLOUD, ServiceTypeEnum.MOBILE_ODIDO, ServiceTypeEnum.MOBILE_KPN, ServiceTypeEnum.CONNECTION, ServiceTypeEnum.SIP_TRUNK,
        ],
        tagsRequireDate: [
          ServiceTagEnum.CLOUD, ServiceTagEnum.SIP_TRUNK, ServiceTagEnum.PHONE_NUMBERS_NEW, ServiceTagEnum.PHONE_NUMBERS_PORTING,
          ServiceTagEnum.CONNECTION, ServiceTagEnum.HARDWARE, ServiceTagEnum.MOBILE, ServiceTagEnum.MOBILE_KPN,
        ],
        dateLabel: 'facturatiedatum'
      },
      {
        status: OrderStatusIdEnum.TERMINATION_REQUESTED,
        servicesRequireDate: [
          ServiceTypeEnum.CLOUD, ServiceTypeEnum.MOBILE_ODIDO, ServiceTypeEnum.MOBILE_KPN, ServiceTypeEnum.CONNECTION, ServiceTypeEnum.SIP_TRUNK,
        ],
        tagsRequireDate: [
          ServiceTagEnum.CLOUD, ServiceTagEnum.SIP_TRUNK, ServiceTagEnum.PHONE_NUMBERS_NEW, ServiceTagEnum.PHONE_NUMBERS_PORTING,
          ServiceTagEnum.CONNECTION, ServiceTagEnum.HARDWARE, ServiceTagEnum.MOBILE, ServiceTagEnum.MOBILE_KPN,
        ],
        dateLabel: 'datum opzegging',
      },
      {
        status: OrderStatusIdEnum.TERMINATED,
        servicesRequireDate: [
          ServiceTypeEnum.MOBILE_ODIDO, ServiceTypeEnum.MOBILE_KPN, ServiceTypeEnum.CONNECTION,
        ],
        tagsRequireDate: [
          ServiceTagEnum.CONNECTION, ServiceTagEnum.HARDWARE, ServiceTagEnum.MOBILE, ServiceTagEnum.MOBILE_KPN,
        ],
        dateLabel: 'datum beëindigd',
      },
    ];

    // COMPUTED
    @Validations()
    get validations() {
      const valData: any = {
        data: {
          status: {required},
          comment: {maxLength: maxLength(255)},
        },
      };

      if (this.data.status && this.statusHasDate(this.data.status)) {
        valData.data.date = {required};
      }

      if (this.currentlySelectedOption('status') === 'Afgewezen') {
        Object.assign(valData.data.comment, {required});
      }

      return valData;
    }

    public dateValueChanged(data: string) {
      this.data.date = data;
    }

    get title() {
      if (this.isChangeSingle) {
        return this.payloadData.title;
      } else {
        return 'Status orderregels wijzigen (' + this.payloadData.title + ')';
      }
    }

    get minimumDate(): string {
      let minimumDate: string = '';

      if (this.currentlySelectedOption('status') === 'Opgezegd') {
        const currentDate = new Date();

        currentDate.setMonth(currentDate.getMonth() + 1);

        minimumDate = currentDate.toDateString();
      } else if (
        this.currentlySelectedOption('status') === 'Beëindigd'
        && this.payloadData.invoiceDate !== undefined
        && this.payloadData.invoiceDate !== null
        && this.payloadData.invoiceDate !== ''
      ) {
        const invoiceDate = new Date(this.payloadData.invoiceDate);
        invoiceDate.setDate(invoiceDate.getDate() + 1);
        minimumDate = invoiceDate.toDateString();
      }

      return minimumDate;
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public currentlySelectedOption(value: any) {
      if (this.data[value] != null) {
        const foundKey = Number(Object.keys(this.selectOptions[value])
          .find((key) => this.selectOptions[value][Number(key)].value === this.data[value]));

        return foundKey != null ? this.selectOptions[value][foundKey].label : null;
      }

      return null;
    }

    public statusFieldChanged(selected: any) {
      this.data.status = null;
      this.data.oldStatus = selected.value;
      this.$emit('setLoad', true);
      axios.post('/-/trade/api/order.status.change.info', {
        transactionId: this.payloadData.id,
        oldStatusId: this.data.oldStatus,
      }).then(
        (response) => {
          this.selectOptions.status = response.data.statuses;
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveDataModal);
        },
      ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('setLoad', true);

        const statusChange = this.isChangeSingle ? this.saveSingle() : this.saveAll();

        statusChange.then(
            (response) => {
              this.close();
              deanDialogBus.$emit('saved', {
                changedOrderLineCount: response.data.length,
                productGroup: this.payloadData.title,
                oldStatus: this.currentlySelectedOption('oldStatus'),
              });
            },
            (error) => {
              const errorMessage: string|null = getErrorFromResponse(
                  error.response.data,
                  this.$store.state.main.notification.messages.couldNotReceiveData.text
              )

              this.$toast({
                icon: warningIcon,
                text: errorMessage ?? '',
                theme: 'danger',
              });
            },
          ).finally(() => {
            this.$emit('setLoad', false);
          });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public statusHasDate(status: string): undefined | StatusObject {
      return this.statusWithDate.find((statusObject: StatusObject) => {

        const serviceType = this.payloadData.serviceType;
        const tag = this.payloadData.tag;

        return (
            statusObject.status === status
            && (
                statusObject.servicesRequireDate.includes(serviceType)
                || statusObject.tagsRequireDate.includes(tag)
            )
        );
      });
    }

    public created() {
      this.isChangeSingle = this.payloadData.isChangeSingle;
      this.$emit('setLoad', true);

      if (this.isChangeSingle) {
        axios.post('/-/trade/api/order.status.change.info', {
          cpId: this.payloadData.id,
          transactionId: '',
          oldStatusId: '',
        }).then(
          (response) => {
            this.selectOptions.status = response.data.statuses;
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveDataModal);
          },
        ).finally(() => {
          this.$emit('setLoad', false);
        });
      } else {
        axios.post('/-/trade/api/order.status.list')
          .then(
            (response) => {
              this.selectOptions.oldStatus = response.data;
            },
            (error) => {
              this.$toast(this.$store.state.main.notification.messages.couldNotReceiveDataModal);
            },
          ).finally(() => {
          this.$emit('setLoad', false);
        });
      }
    }

    private saveSingle() {
      return axios.post('/-/trade/api/order.status.change.line', {
        id: this.payloadData.id,
        statusId: this.data.status,
        date: this.data.date,
        comment: this.data.comment,
      });
    }

    private saveAll() {
      return axios.post('/-/trade/api/order.status.change.all', {
        id: this.payloadData.id,
        statusId: this.data.status,
        oldStatusId: this.data.oldStatus,
        tag: this.payloadData.tag,
        date: this.data.date,
        comment: this.data.comment,
      });
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

:deep(.dialog .dean-dialog-container .dean-dialog-content .dean-dialog-slot) {
  overflow-y: visible;
}

</style>